import { render, staticRenderFns } from "./BreadCump.vue?vue&type=template&id=44e9ac1f&scoped=true&"
import script from "./BreadCump.vue?vue&type=script&lang=js&"
export * from "./BreadCump.vue?vue&type=script&lang=js&"
import style0 from "./BreadCump.vue?vue&type=style&index=0&id=44e9ac1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e9ac1f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBreadcrumbs,VBreadcrumbsItem,VIcon})
